import type { DataTableColumnVisibilitySettingsProps } from './column-settings-types.js';

/**
 * The slot component serves the sole purpose of detecting the user's intention
 * to display column visibility within the column settings modal, situated in the DataTable toolbar.
 * @public
 */
export const DataTableColumnVisibilitySettings = ({
  resetColumnVisibility,
}: DataTableColumnVisibilitySettingsProps) => null;

DataTableColumnVisibilitySettings.displayName = 'DataTable.VisibilitySettings';
